/* Aerless BOGO Landing (Offer B: 3-option picker) — behaviour, extracted from the section and driven by
   window.AER_CONFIG (rendered by sections/bogo-landing.liquid from theme settings). */
(function () {
  var CFG = window.AER_CONFIG || {};
  function pad(v) { return v < 10 ? '0' + v : '' + v; }

  /* ---------------- Bundle picker + checkout ---------------- */
  (function () {
    var bundles = Array.prototype.slice.call(document.querySelectorAll('#bundle-1, #bundle-2, #bundle-3'));
    if (!bundles.length) return;
    var ctaPrice = document.getElementById('cta-price');
    var ctaCompare = document.getElementById('cta-compare');
    var selected = document.getElementById('bundle-1') || bundles[0];

    function setText(id, v) { var el = document.getElementById(id); if (el && v != null) el.textContent = v; }

    function select(btn) {
      if (!btn) return;
      selected = btn;
      bundles.forEach(function (b) {
        var on = (b === btn);
        b.classList.toggle('border-[#FF5801]', on);
        b.classList.toggle('bg-orange-50', on);
        b.classList.toggle('border-gray-200', !on);
        b.classList.toggle('hover:border-gray-300', !on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var d = btn.dataset;
      /* All price strings are pre-formatted by Liquid (`money` filter) so the
         currency follows the store / buyer market automatically. */
      if (ctaPrice && d.priceFmt) ctaPrice.textContent = d.priceFmt;
      if (ctaCompare && d.compareFmt) ctaCompare.textContent = d.compareFmt;
      setText('sum-line', d.sumlineFmt);
      setText('sum-subtotal', d.priceFmt);
      setText('sum-total', d.priceFmt);
    }

    bundles.forEach(function (b) {
      b.style.cursor = 'pointer';
      b.addEventListener('click', function () { select(b); });
      /* per-unit "<price>/each" label lives inside each bundle button */
      var ef = b.dataset.eachFmt;
      if (ef) {
        var p = [].slice.call(b.querySelectorAll('p')).find(function (x) { return /\/each$/.test(x.textContent.trim()); });
        if (p) p.textContent = ef;
      }
    });

    function checkout() {
      var d = (selected && selected.dataset) || {};
      /* Add ONE multi-pack variant (qty defaults to 1) instead of N single packs. */
      var variant = d.variant || CFG.defaultVariant;
      var qty = d.qty || '1';
      if (!variant) return;
      var shop = CFG.shop || '';
      var cart = '/cart/' + variant + ':' + qty;
      var url = CFG.discountCode
        ? '/discount/' + encodeURIComponent(CFG.discountCode) + '?redirect=' + encodeURIComponent(cart)
        : cart;
      window.location.href = shop + url;
    }
    ['claim-cta', 'claim-cta-2'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.addEventListener('click', checkout);
    });

    select(selected); /* sync UI with the default selection */
  })();
  /* ---------------- Sticky "Claim Offer" bar (shows after scrolling past CTA) ---------------- */
  (function () {
    var cta = document.getElementById('claim-cta');
    if (!cta || document.getElementById('aer-sticky-cta')) return;

    var bar = document.createElement('div');
    bar.id = 'aer-sticky-cta';
    bar.style.cssText = 'position:fixed;left:0;right:0;bottom:0;z-index:50;'
      + 'background:#fff;padding:10px 16px;box-shadow:0 -4px 16px rgba(0,0,0,0.12);'
      + 'transform:translateY(120%);transition:transform .25s ease;'
      + 'display:flex;justify-content:center;';

    var lbl = (cta.querySelector('span span') || {}).textContent || 'Claim Offer';
    var cmp = (document.getElementById('cta-compare') || {}).textContent || '';
    var prc = (document.getElementById('cta-price') || {}).textContent || '';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.style.cssText = 'width:100%;max-width:480px;background:#FF5801;color:#fff;border:0;'
      + 'border-radius:9999px;padding:14px 20px;font-weight:700;font-size:1rem;cursor:pointer;'
      + 'display:flex;align-items:center;justify-content:center;gap:0.5rem;';
    btn.innerHTML =
        '<span>' + lbl + '</span>'
      + '<span style="display:flex;align-items:center;gap:0.5rem;background:rgba(255,255,255,0.12);'
          + 'font-size:0.875rem;border-radius:100px;padding:0.25rem 0.5rem 0.25rem 0.75rem;">'
        + '<span id="aer-sticky-compare" style="text-decoration:line-through;opacity:0.6;">' + cmp + '</span>'
        + '<span id="aer-sticky-price">' + prc + '</span>'
      + '</span>'
      + '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" width="20" height="20" viewBox="0 0 20 20" style="flex-shrink:0;">'
        + '<path fill="currentColor" fill-rule="evenodd" d="M3 10a.75.75 0 0 1 .75-.75h10.638L10.23 5.29a.75.75 0 1 1 1.04-1.08l5.5 5.25a.75.75 0 0 1 0 1.08l-5.5 5.25a.75.75 0 1 1-1.04-1.08l4.158-3.96H3.75A.75.75 0 0 1 3 10Z" clip-rule="evenodd"></path>'
      + '</svg>';
    btn.addEventListener('click', function () { cta.click(); });

    /* keep the sticky price/compare in sync with the main CTA when the bundle changes */
    if ('MutationObserver' in window) {
      var srcP = document.getElementById('cta-price');
      var srcC = document.getElementById('cta-compare');
      var dstP = btn.querySelector('#aer-sticky-price');
      var dstC = btn.querySelector('#aer-sticky-compare');
      var mo = new MutationObserver(function () {
        if (srcP && dstP) dstP.textContent = srcP.textContent;
        if (srcC && dstC) dstC.textContent = srcC.textContent;
      });
      if (srcP) mo.observe(srcP, { childList: true, characterData: true, subtree: true });
      if (srcC) mo.observe(srcC, { childList: true, characterData: true, subtree: true });
    }

    bar.appendChild(btn);
    document.body.appendChild(bar);

    function show() { bar.style.transform = 'translateY(0)'; }
    function hide() { bar.style.transform = 'translateY(120%)'; }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        /* show only once the button has scrolled ABOVE the top of the screen */
        if (!e.isIntersecting && e.boundingClientRect.top < 0) show();
        else hide();
      }, { threshold: 0 });
      io.observe(cta);
    }
  })();
  /* ---------------- Dynamic "Ships FREE by <date>" ---------------- */
  (function () {
    var el = document.getElementById('aer-ship-date');
    if (!el) return;
    var offset = (CFG.shipOffsetDays != null) ? Number(CFG.shipOffsetDays) : 1;
    var d = new Date();
    d.setDate(d.getDate() + offset); /* relative to the day the visitor loads the page */
    try {
      el.textContent = d.toLocaleDateString(CFG.locale || undefined, { weekday: 'short', month: 'short', day: 'numeric' });
    } catch (e) {
      el.textContent = d.toDateString();
    }
  })();

  /* ---------------- Gallery carousel ---------------- */
  (function () {
    var track = document.getElementById('aer-gal-track');
    if (!track) return;
    var slides = track.children.length, idx = 0;
    var hero = track.closest('[data-section-id="s_hero"]') || document;
    var stage = track.parentElement;
    var dotsWrap = stage.querySelector('.absolute.bottom-2');
    var dots = dotsWrap ? [].slice.call(dotsWrap.querySelectorAll('button')) : [];
    var thumbs = [].slice.call(hero.querySelectorAll('img[alt^="View "]')).map(function (im) { return im.closest('button'); });
    var nextBtn = stage.querySelector('button.absolute.right-2');
    var prevBtn = null;
    function render() {
      track.style.transform = 'translateX(' + (-idx * 100) + '%)';
      dots.forEach(function (d, k) { d.className = 'w-2 h-2 rounded-full transition-colors ' + (k === idx ? 'bg-[#FF5801]' : 'bg-black/20'); });
      thumbs.forEach(function (t, k) { if (t) t.className = 'relative flex-shrink-0 w-14 h-14 sm:w-16 sm:h-16 rounded-md overflow-hidden border-2 transition-colors ' + (k === idx ? 'border-[#FF5801]' : 'border-transparent'); });
      if (prevBtn) prevBtn.style.display = idx === 0 ? 'none' : '';
    }
    function go(n) { idx = (n + slides) % slides; render(); }
    if (nextBtn) {
      prevBtn = nextBtn.cloneNode(true);
      prevBtn.className = nextBtn.className.replace('right-2', 'left-2');
      var ps = prevBtn.querySelector('svg'); if (ps) ps.style.transform = 'rotate(180deg)';
      stage.appendChild(prevBtn);
      nextBtn.addEventListener('click', function (e) { e.preventDefault(); go(idx + 1); });
      prevBtn.addEventListener('click', function (e) { e.preventDefault(); go(idx - 1); });
    }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
    thumbs.forEach(function (t, k) { if (t) t.addEventListener('click', function () { go(k); }); });
     /* ---- touch swipe ---- */
    var swStartX = null, swStartY = null;
    stage.addEventListener('touchstart', function (e) {
      var t = e.changedTouches[0];
      swStartX = t.clientX; swStartY = t.clientY;
    }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (swStartX === null) return;
      var t = e.changedTouches[0];
      var dx = t.clientX - swStartX, dy = t.clientY - swStartY;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        if (dx < 0) go(idx + 1); else go(idx - 1);
      }
      swStartX = swStartY = null;
    }, { passive: true });
    render();
  })();

  /* ---------------- Tabs ---------------- */
  (function () {
    var LABELS = ['Benefits', 'Why Aerless', 'How It Works'];
    var tabBtns = [].slice.call(document.querySelectorAll('button')).filter(function (b) {
      var t = b.textContent.trim();
      if (LABELS.indexOf(t) < 0 || !b.parentElement) return false;
      var sib = [].slice.call(b.parentElement.children).filter(function (c) { return LABELS.indexOf(c.textContent.trim()) >= 0; });
      return sib.length >= 2;
    });
    if (tabBtns.length !== 3) return;
    var panel = tabBtns[0].parentElement.nextElementSibling;
    var benefitsHTML = panel.innerHTML;
    function stp(n, t, d) {
      return '<div class="flex items-start gap-3"><span class="flex-shrink-0 w-6 h-6 rounded-full bg-[#FF5801] text-white text-xs font-bold flex items-center justify-center">' + n + '</span>'
        + '<div><p class="font-semibold text-sm">' + t + '</p><p class="text-xs text-gray-600 leading-relaxed">' + d + '</p></div></div>';
    }
    var whyHTML = '<div class="space-y-3">'
      + '<p class="text-sm text-gray-600 text-center mb-1">See how the Aerless™ Vacuum Kit compares to cheap kits and regular packing.</p>'
      + '<img src="https://cdn.shopify.com/s/files/1/0924/3502/2169/files/Aerless_ComparisonTable_Desktop.jpg?v=1780418084&width=1100" alt="Aerless Vacuum Kit compared to cheap vacuum kits and no vacuum bags" class="w-full rounded-lg border border-gray-100">'
      + '</div>';
    var howHTML = '<div class="space-y-4">'
      + '<div class="rounded-lg overflow-hidden border border-gray-100 bg-gray-100"><video class="w-full block" autoplay muted loop playsinline preload="metadata" poster="https://cdn.shopify.com/s/files/1/0924/3502/2169/files/preview_images/0af2651eaab74ec296ee0e898d03b5ff.thumbnail.0000000000.jpg?v=1752053681"><source src="https://www.aerless.com/cdn/shop/videos/c/vp/0af2651eaab74ec296ee0e898d03b5ff/0af2651eaab74ec296ee0e898d03b5ff.HD-1080p-2.5Mbps-50887469.mp4" type="video/mp4"></video></div>'
      + '<div class="space-y-3.5">'
      + stp(1, 'Fill the bag', 'Roll in 15+ items, clothes, towels, even bedding.')
      + stp(2, 'Seal the airtight zip', 'Slide it shut for a fully closed, leak-proof seal.')
      + stp(3, 'Compress', 'Use the included USB-C Air Pump anywhere, or any vacuum cleaner at home.')
      + stp(4, 'Pack and go', 'Enjoy up to 60% more space in any carry-on, backpack, or suitcase.')
      + '</div></div>';
    var htmls = [benefitsHTML, whyHTML, howHTML];
    function setTab(i) {
      tabBtns.forEach(function (b, k) {
        var on = k === i;
        b.style.backgroundColor = on ? '#ffffff' : '#f9fafb';
        b.style.color = on ? '#000000' : '#4b5563';
        b.style.borderBottom = on ? '2px solid #FF5801' : '2px solid transparent';
      });
      panel.innerHTML = htmls[i];
    }
    tabBtns.forEach(function (b, k) { b.addEventListener('click', function () { setTab(k); }); });
    setTab(0);
  })();

  /* ---------------- FAQ accordion ---------------- */
  (function () {
    /* Answers are now rendered into the DOM by Liquid as a hidden div that is
       the next sibling of each question button. We just toggle it. */
    [].slice.call(document.querySelectorAll('button.w-full')).forEach(function (btn) {
      var span = btn.querySelector('span.font-semibold.text-base.pr-4');
      if (!span) return;
      var ap = btn.nextElementSibling;
      if (!ap) return;
      var chev = btn.querySelector('svg');
      if (chev) chev.style.transition = 'transform 0.2s ease';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var open = ap.style.display !== 'none';
        ap.style.display = open ? 'none' : '';
        if (chev) chev.style.transform = open ? '' : 'rotate(180deg)';
      });
    });
  })();

  /* ---------------- Scroll-reveal + tab label sizing ---------------- */
  (function () {
    var els = [].slice.call(document.querySelectorAll('[style*="opacity: 0"][style*="translateY"]'));
    function reveal(el) { el.style.opacity = '1'; el.style.transform = 'none'; }
    if (els.length) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) { reveal(e.target); io.unobserve(e.target); } });
        }, { threshold: 0.08, rootMargin: '0px 0px -8% 0px' });
        els.forEach(function (el) { io.observe(el); });
        setTimeout(function () { els.forEach(reveal); }, 3500); /* safety net */
      } else {
        els.forEach(reveal);
      }
    }
    var LABELS = ['Benefits', 'Why Aerless', 'How It Works'];
    [].slice.call(document.querySelectorAll('button')).forEach(function (b) {
      var t = b.textContent.trim();
      if (LABELS.indexOf(t) < 0 || !b.parentElement) return;
      var sib = [].slice.call(b.parentElement.children).filter(function (c) { return LABELS.indexOf(c.textContent.trim()) >= 0; });
      if (sib.length < 2) return;
      b.style.fontSize = '0.78rem';
      b.style.whiteSpace = 'nowrap';
      b.style.padding = '0.5rem 0.25rem';
      b.style.letterSpacing = '-0.01em';
    });
  })();

  /* ---------------- "X Reviews" -> smooth scroll to reviews ---------------- */
  (function () {
    var rv = [].slice.call(document.querySelectorAll('span')).find(function (s) { return /Reviews$/.test(s.textContent.trim()); });
    var sec = document.querySelector('[data-section-id="s_reviews"]');
    if (!rv || !sec) return;
    var targets = [rv];
    var chev = rv.nextElementSibling;
    if (chev && String(chev.tagName).toLowerCase() === 'svg') targets.push(chev);
    rv.style.textDecoration = 'underline';
    rv.style.textDecorationThickness = '1px';
    rv.style.textUnderlineOffset = '2px';
    rv.setAttribute('role', 'link');
    rv.setAttribute('title', 'See reviews');
    function go(e) {
      e.preventDefault();
      var startY = window.scrollY || document.documentElement.scrollTop;
      var endY = sec.getBoundingClientRect().top + startY - 60;
      var dur = 650, t0 = null;
      function ease(p) { return p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2; }
      function step(ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min((ts - t0) / dur, 1);
        window.scrollTo(0, startY + (endY - startY) * ease(p));
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    targets.forEach(function (el) { el.style.cursor = 'pointer'; el.addEventListener('click', go); });
  })();

  /* ---------------- Header countdown -> next local midnight ---------------- */
  (function () {
    var boxes = [].slice.call(document.querySelectorAll('[data-section-id="s_announcement"] .font-mono .text-center > span:first-child'));
    if (boxes.length !== 4) return;
    function tick() {
      var end = new Date(); end.setHours(24, 0, 0, 0);
      var rem = Math.max(0, Math.floor((end.getTime() - Date.now()) / 1000));
      boxes[0].textContent = pad(Math.floor(rem / 86400));
      boxes[1].textContent = pad(Math.floor((rem % 86400) / 3600));
      boxes[2].textContent = pad(Math.floor((rem % 3600) / 60));
      boxes[3].textContent = pad(rem % 60);
    }
    tick(); setInterval(tick, 1000);
  })();

  /* ---------------- "Order reserved for" timer (configurable, honest expiry) ---------------- */
  (function () {
    if (CFG.urgencyEnabled === false) return;
    var rsv = [].slice.call(document.querySelectorAll('span')).find(function (s) {
      return /^\d{1,2}:\d{2}$/.test(s.textContent.trim()) &&
             /reserved for/i.test((s.parentElement && s.parentElement.textContent) || '');
    });
    if (!rsv) return;
    var minutes = Number(CFG.urgencyMinutes) || 10;
    var loop = CFG.urgencyLoop === true; /* default: count down once, then stop at 0:00 */
    var KEY = 'aer_reserve_until';
    var until = parseInt(sessionStorage.getItem(KEY) || '0', 10);
    if (!until) { until = Date.now() + minutes * 60000; sessionStorage.setItem(KEY, String(until)); }
    var timer = setInterval(tick, 1000); tick();
    function tick() {
      var rem = Math.round((until - Date.now()) / 1000);
      if (rem <= 0) {
        if (loop) { until = Date.now() + minutes * 60000; sessionStorage.setItem(KEY, String(until)); rem = minutes * 60; }
        else { rsv.textContent = '0:00'; clearInterval(timer); return; }
      }
      rsv.textContent = Math.floor(rem / 60) + ':' + pad(rem % 60);
    }
  })();
})();
